import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import { t } from "../i18n/translations";
import { Sprout, Flame, Droplets, ArrowUpRight } from "lucide-react";

const HERO = "https://images.pexels.com/photos/6560254/pexels-photo-6560254.jpeg";

export default function Ernaehrung() {
  const { lang } = useLang();
  const pillars = t(lang, "ernaehrung.pillars") || [];
  const icons = [Sprout, Flame, Droplets];
  const tints = ["bg-sage/10 text-sage", "bg-terracotta/10 text-terracotta", "bg-ink/10 text-ink"];

  return (
    <div data-testid="ernaehrung-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">— {t(lang, "ernaehrung.subtitle")}</div>
          <h1 className="font-display text-5xl lg:text-6xl text-ink leading-tight">{t(lang, "ernaehrung.title")}</h1>
          <p className="mt-8 text-lg text-ink-muted leading-relaxed">{t(lang, "ernaehrung.lead")}</p>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] rounded-md overflow-hidden bg-muted">
            <img src={HERO} alt="" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      {/* Doshas */}
      <section className="bg-muted/60 border-y border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
          <h2 className="font-display text-4xl text-ink mb-10">{t(lang, "ernaehrung.pillars_title")}</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {pillars.map((p, i) => {
              const Icon = icons[i];
              return (
                <div key={p.name} className="bg-white border border-border rounded-md p-8" data-testid={`dosha-${p.name.toLowerCase()}`}>
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-5 ${tints[i]}`}>
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-display text-3xl text-ink">{p.name}</h3>
                  <p className="mt-3 text-ink-muted leading-relaxed text-sm">{p.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Consultation */}
      <section className="max-w-4xl mx-auto px-6 lg:px-12 py-20 text-center">
        <h2 className="font-display text-4xl text-ink leading-tight">{t(lang, "ernaehrung.consult_title")}</h2>
        <p className="mt-6 text-ink-muted leading-relaxed max-w-2xl mx-auto">{t(lang, "ernaehrung.consult_body")}</p>
        <Link to="/standort" className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-terracotta text-white rounded-full hover:bg-terracotta-hover" data-testid="ernaehrung-cta">
          {t(lang, "ernaehrung.consult_cta")} <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
        </Link>
      </section>
    </div>
  );
}
